// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3p8Du","form":"styles_form__2GYbO"};